import PropTypes from 'prop-types';
import { STAT_CARD_BASE } from '../../ui/StatCard';
import { EditorHeading, Field, NumberInput, TextInput, inputCls } from './EditorFields';

/**
 * The numbers the business is judged on.
 *
 * Metrics can be renamed and re-targeted here, but not added or removed: every
 * decision card already carries a number for each one, and a metric added after the
 * AI wrote the decks would be one that no option ever moves.
 */
const MetricsEditor = ({ kpis, onChange }) => {
  const set = (i, field, value) =>
    onChange(kpis.map((k, x) => {
      if (x !== i) return k;
      // "Balance it" is read as distance either way from the start.
      if (field === 'direction') return { ...k, direction: value, normaliseAbs: value === 'neutral' };
      return { ...k, [field]: value };
    }));

  return (
    <div className={`${STAT_CARD_BASE} p-5`}>
      <EditorHeading title="The numbers this business lives or dies by">
        Starts at is where the business is today. A target is optional: leave it empty and only
        the direction counts; set one and the results show whether the room reached it. Cap is
        the biggest realistic change across the whole session — it only scales the bars.
      </EditorHeading>

      <div className="space-y-3">
        {kpis.map((k, i) => (
          <div key={k.key} className="rounded-xl border border-neutral-200 p-3.5 dark:border-neutral-700/60">
            <div className="grid gap-2 sm:grid-cols-[1.4fr_1fr_1fr]">
              <Field label="Metric">
                <TextInput value={k.label} onChange={(v) => set(i, 'label', v)} />
              </Field>
              <Field label="Unit">
                <TextInput value={k.unit} onChange={(v) => set(i, 'unit', v)} />
              </Field>
              <Field label="Good is">
                <select value={k.direction} onChange={(e) => set(i, 'direction', e.target.value)} className={inputCls}>
                  <option value="lower">Lower is better</option>
                  <option value="higher">Higher is better</option>
                  <option value="neutral">Balance it</option>
                </select>
              </Field>
            </div>
            <div className="mt-2 grid grid-cols-3 gap-2">
              <Field label="Starts at">
                <NumberInput value={k.start} onChange={(v) => set(i, 'start', v)} placeholder="0" />
              </Field>
              <Field label={k.direction === 'neutral' ? 'Keep within ±' : 'Target'}>
                <NumberInput value={k.target} onChange={(v) => set(i, 'target', v)} placeholder="None" />
              </Field>
              <Field label="Cap">
                <NumberInput value={k.cap} onChange={(v) => set(i, 'cap', v)} />
              </Field>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

MetricsEditor.propTypes = {
  kpis: PropTypes.arrayOf(PropTypes.object).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default MetricsEditor;
